export interface AppConfig {
  apiGateway: string;
  env: Environment;
  appName: string;
}

export enum Environment {
  DEV,
  LOCAL, // web and api need https
  TEST_unstable,
  TEST_stable,
  INT,
  PROD,
}
